import type { ChakraStylesConfig, GroupBase } from 'chakra-react-select';

export const BaseSelectStyles: ChakraStylesConfig<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  any,
  boolean,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  GroupBase<any>
> = {
  container: (provided) => ({
    ...provided,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 0,
    gap: '8px',
    boxSizing: 'border-box',
    width: '100%',
    height: '32px',
    background: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: '4px',
  }),
  control: (provided) => ({
    ...provided,
    minHeight: '32px',
    height: '32px',
    background: 'transparent',
    borderWidth: 0,
    boxShadow: 'none',
    padding: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    fontSize: '14px',
    padding: 0,
    paddingLeft: '8px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: 0,
  }),
  clearIndicator: (provided) => ({
    ...provided,
    width: '16px',
    height: '16px',
    '> svg': {
      width: '8px',
      height: '8px',
    },
  }),
  group: (provided) => ({
    ...provided,
    ':not(:last-of-type)': {
      marginBottom: '12px',
      paddingBottom: '12px',
      boxShadow: '0px 24px 3px -24px #CDD7EA',
    },
  }),
  groupHeading: (provided) => ({
    ...provided,
    fontSize: '14px',
    color: 'navyBlue.300',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#DEF5EE' : 'transparent',
    fontSize: '14px',
    color: 'text.primary',
    ':active': {
      backgroundColor: '#DEF5EE',
      color: 'black',
    },
  }),
};

export const SimpleSelectStyles = <TOption>(): ChakraStylesConfig<TOption> => ({
  container: (prev) => ({
    ...prev,
    width: '100%',
    height: '24px',
    fontSize: '12px',
    fontWeight: 400,
  }),
  control: (prev) => ({
    ...prev,
    minHeight: '100%',
    height: '100%',
    backgroundColor: '#F1F5F9',
    border: 'none',
    boxShadow: 'none',
  }),
  valueContainer: (prev) => ({
    ...prev,
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    fontSize: '12px',
  }),
  placeholder: (prev) => ({
    ...prev,
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    pointerEvents: 'none',
  }),
  indicatorsContainer: (prev) => ({
    ...prev,
    height: '100%',
    svg: { width: '12px', height: '12px' },
  }),
  indicatorSeparator: (prev) => ({ ...prev, display: 'none' }),
  dropdownIndicator: (prev) => ({
    ...prev,
    color: '#2D426A',
    ' svg': {
      width: '12px',
      height: '12px',
    },
  }),
  menu: (prev) => ({
    ...prev,
    borderRadius: 0,
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 3,
  }),
  option: (prev, { isSelected, isFocused }) => ({
    ...prev,
    backgroundColor: isSelected || isFocused ? '#DEF5EE' : 'transparent',
    color: '#2D426A',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    cursor: 'pointer',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  }),
});
